import { VBaseCheckboxRadio } from '../VBaseCheckboxRadio';
import VInnerCheckbox from './VInnerCheckbox';
import type { VCheckboxProps } from './type';

const VCheckbox = ({ value, ...props }: VCheckboxProps) => {
  return (
    <VBaseCheckboxRadio {...props}>
      <VInnerCheckbox value={value} size={props.size} />
    </VBaseCheckboxRadio>
  );
};

export default VCheckbox;
